import { render } from "./userCenter.vue?vue&type=template&id=8b1ace24&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"

import "./userCenter.vue?vue&type=style&index=0&id=8b1ace24&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8b1ace24"

export default script